import React from 'react';
import { ShieldCheck, Lock, Award } from 'lucide-react';
export function Security() {
  return <section className="py-16 bg-white border-y border-stone-100" data-id="element-192">
      <div className="max-w-5xl mx-auto px-6" data-id="element-193">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-194">
          <div className="flex flex-col items-center p-6" data-id="element-195">
            <div className="w-16 h-16 rounded-full bg-[#FAF5E9] flex items-center justify-center mb-4" data-id="element-196">
              <Lock className="w-8 h-8 text-[#C5A059]" data-id="element-197" />
            </div>
            <h3 className="font-bold text-stone-900 mb-2" data-id="element-198">Pago 100% Seguro</h3>
            <p className="text-stone-500 text-sm" data-id="element-199">
              Cifrado de alta seguridad de nivel bancario.
            </p>
          </div>

          <div className="flex flex-col items-center p-6" data-id="element-200">
            <div className="w-16 h-16 rounded-full bg-[#FAF5E9] flex items-center justify-center mb-4" data-id="element-201">
              <ShieldCheck className="w-8 h-8 text-[#C5A059]" data-id="element-202" />
            </div>
            <h3 className="font-bold text-stone-900 mb-2" data-id="element-203">Privacidad Total</h3>
            <p className="text-stone-500 text-sm" data-id="element-204">
              Jamás compartiremos tu información personal.
            </p>
          </div>

          <div className="flex flex-col items-center p-6" data-id="element-205">
            <div className="w-16 h-16 rounded-full bg-[#FAF5E9] flex items-center justify-center mb-4" data-id="element-206">
              <Award className="w-8 h-8 text-[#C5A059]" data-id="element-207" />
            </div>
            <h3 className="font-bold text-stone-900 mb-2" data-id="element-208">Calidad Premium</h3>
            <p className="text-stone-500 text-sm" data-id="element-209">
              Contenido testeado y validado por miles de mujeres.
            </p>
          </div>
        </div>
      </div>
    </section>;
}